import { render, staticRenderFns } from "./NavbarItem.vue?vue&type=template&id=16c0048e&scoped=true"
import script from "./NavbarItem.vue?vue&type=script&lang=ts"
export * from "./NavbarItem.vue?vue&type=script&lang=ts"
import style0 from "./NavbarItem.vue?vue&type=style&index=0&id=16c0048e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c0048e",
  null
  
)

export default component.exports